import { KotlinLoggingConfiguration_getInstance2afdiujdk3hao as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KotlinLoggingClass;
function KotlinLogging() {
  if (KotlinLoggingClass === VOID) {
    class $ {
      constructor() {
        KotlinLogging_instance = this;
        var factory = KotlinLoggingConfiguration_getInstance().i2h_1;
        if (KotlinLoggingConfiguration_getInstance().g2h_1) {
          println('kotlin-logging: initializing... active logger factory: ' + getKClassFromExpression(factory).j1());
        }
      }
      l2h(name) {
        return KotlinLoggingConfiguration_getInstance().i2h_1.l2h(name);
      }
    }
    initMetadataForObject($, 'KotlinLogging');
    KotlinLoggingClass = $;
  }
  return KotlinLoggingClass;
}
var KotlinLogging_instance;
function KotlinLogging_getInstance() {
  if (KotlinLogging_instance === VOID)
    new (KotlinLogging())();
  return KotlinLogging_instance;
}
//region block: exports
export {
  KotlinLogging_getInstance as KotlinLogging_getInstance2o4ipkbfqihwo,
};
//endregion

//# sourceMappingURL=KotlinLogging.mjs.map
